import { Injectable } from '@angular/core';
import { Observable, Subject, timer } from 'rxjs';
import { ClockModel } from './clock-model';
import { shareReplay, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ClockService {

  clock: Observable<Date>;
  infofecha$ = new Subject<ClockModel>();
  vr: ClockModel;
  ampm: string;
  hours: number;
  minute: string;
  weekday: string;
  months: string;
  constructor() {
    this.clock = timer(0, 1000).pipe(map(t => new Date()), shareReplay(1));
  }
  getInfoReloj(): Observable<ClockModel> {
    this.clock.subscribe(t => {
      this.hours = t.getHours() % 12;
      this.hours = this.hours ? this.hours : 12;
      this.vr = {
        hora: this.hours,
        minutos: (t.getMinutes() < 10) ? '0' + t.getMinutes() : t.getMinutes().toString(),
        ampm: t.getHours() > 11 ? 'PM' : 'AM',
        diaymes: t.toLocaleString('es-MX', { day: '2-digit', month: 'long' }).replace('.', '').replace('-', ' '),
        diademes: t.toLocaleString('es-MX', { day: '2-digit' }).replace('.', '').replace('-', ' '),
        mes: t.toLocaleString('es-MX', { month: 'long' }).replace('.', ''),
        anyo: new Date().getFullYear().toString(),
        diadesemana: t.toLocaleString('es-MX', { weekday: 'long' }).replace('.', ''),
        segundo: t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds().toString()
      }
      this.infofecha$.next(this.vr);
    });
    return this.infofecha$.asObservable();
  }
}
